import Client from '../axios-client';

const resource = '/import/imports';

export default {
  create: function(data) {
    return Client.post(`${resource}`, data,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    )
  },
  book(importId, payload) {
    return Client.put(`${resource}/${importId}/booked`, payload);
  },
  getImportsGrid(parameters) {
    return Client.get(`${resource}` + parameters);
  },
  getImport(importId) {
    return Client.get(`${resource}/${importId}`);
  },
  getImportOperationsGrid(importId, parameters) {
    return Client.get(`${resource}/${importId}/operations` + parameters);
  },
};
